import i18n from "i18next";
import { removePrefix } from "../../common";
import { isFeedBlock } from "../../guards";
import { AdTags, AnalyticsTags, TagContext, Tagger, Tags } from "../type";
import { generateMetaTag, setGeneralMetaTags } from "../util";

export const feedTags: Tagger = (state: Tags, context: TagContext) => {
    const { site, block } = context;

    if (block && isFeedBlock(block)) {
        let titles = null;
        let description = "";
        let { title } = block.value;
        if (title) {
            const name = site.sections.general?.name || "";
            title = `${title} | ${name}`;

            titles = {
                default: title,
                social: title,
            };

            description = i18n.t("collection_description", { title, name }) || "";
        }

        const topics: string[] = [];
        if (block.feed?.resume) {
            const { "<topic>": topic } = block.feed.resume.context;
            if (topic) {
                topics.push(removePrefix(/^\w+\//)(topic));
            }
        }

        let { metadata } = state;
        metadata = setGeneralMetaTags(metadata, {
            titles,
            description,
            types: {
                parsely: "sectionpage",
            },
        });

        metadata.set(...generateMetaTag("name", "parsely-section", "topic"));

        return {
            ...state,
            ads: {
                ...state.ads,
                topics,
            } as AdTags,
            analytics: {
                ...state.analytics,
                view: {
                    ...state.analytics?.view,
                    topics,
                },
            } as AnalyticsTags,
            metadata,
        };
    }
    return state;
};
